import React from 'react'
import PropTypes from 'prop-types'
import { FormationTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const GestionFormations = ({
  fetchData,
  fetchFiles,
  isLoadingFormationsList,
  formations,
  formationsCount,

  errorMessage,
  removeError,
  isErrorFetch,

  pageLimitChanged,
  pageChanged,

  success,
  isSuccessRefresh,
  resetSuccessAction,

  searchData,

  onCloseReset,
  fetchDataById,

  errorMessageConfig,
  removeErrorConfig,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={FormationTableHead}
      //Commonfields
      globalID={'Formations'}
      searchPlaceholder={'Rechercher par formation'}
      title={'Gestion formations'}
      fetchData={fetchData}
      loadingData={isLoadingFormationsList}
      dataList={formations}
      countData={formationsCount}
      errorMessage={errorMessage || errorMessageConfig}
      removeError={removeError}
      removeErrorConfig={removeErrorConfig}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      fetchDataById={fetchDataById}
      fetchFiles={fetchFiles}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isFormation={true}
    />
  )
}
GestionFormations.propTypes = {
  fetchData: PropTypes.func,
  isLoadingFormationsList: PropTypes.bool,
  formations: PropTypes.array,
  formationsCount: PropTypes.number,

  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,

  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,

  success: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,

  searchData: PropTypes.func,
  onCloseReset: PropTypes.func,
  fetchFiles: PropTypes.func,

  errorMessageConfig: PropTypes.string,
  removeErrorConfig: PropTypes.func,
  fetchDataById: PropTypes.func,
}
export default GestionFormations
